import React from 'react';

const Tribe = () => {
    return (
        <div className="flex justify-center items-center h-screen sm:text-lg text-xs ">
            <h1 className="text-center sm:text-lg text-xs">
                You can keep this page blank, and we will not have this function yet.
                <span className="sm:text-lg text-xs font-bold block">
                    We will come back after the Kickstarter launch.
                </span>
            </h1>
        </div>
    );
};

export default Tribe;
